import React from 'react'
import { ChevronDown } from 'lucide-react'

export default function ExpandToggleButton({
  isExpanded = false,
  onToggle,
  labelMore,
  labelLess,
  className = '',
}) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div className="flex-1 h-px bg-color-border-light"></div>
      <button
        onClick={onToggle}
        className={`flex items-center gap-2 typography-meta-on-dark uppercase hover:text-primary-on-dark transition-colors cursor-pointer ${!isExpanded ? 'animate-pulse-soft' : ''}`}
      >
        {isExpanded ? labelLess : labelMore}
        <ChevronDown className={`chevron transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
      </button>
      <div className="flex-1 h-px bg-color-border-light"></div>
    </div>
  )
}
